import { FRATRiskLevel } from '../models/flights';

export default function fratRiskColour(fratRiskLevel: FRATRiskLevel): string {
  let colour = 'green';
  if (fratRiskLevel === FRATRiskLevel.HIGH) colour = 'red';
  if (fratRiskLevel === FRATRiskLevel.MEDIUM) colour = 'amber';
  return colour;
}
